import "./about.css";

const About = () => {
  return (
    <section className="about">
      <h1>About Us</h1>
      <p>We are an online book store</p>
      <p>
        <strong>Version: 1.0.0</strong>
      </p>
    </section>
  );
};

export default About;
